document.addEventListener("DOMContentLoaded", function () {
  var rightWrap = document.querySelector(".aqmos-form__right--wrap");
  var mediaQuery = window.matchMedia("(max-width: 992px)");
  var nextBtn = document.getElementById("nextBtn");
  var radios = document.querySelectorAll('.gfield input[type="radio"]');
  var specBtn = document.getElementById("specs-btn");
  var modalCloser = document.getElementById("closemodal");
  var sidebar = document.querySelector(".aqmos-sidebar");
  var backdrop = document.querySelector(".aqmos-sidebar__backdrop");
  var specsList = document.getElementById("specslist");
  var productContent = document.getElementById("productContent");
  var productTitle = document.getElementById("modelname");
  var price = document.getElementById("price");
  var model = document.getElementById("input_2_20");
  var priceField = document.getElementById("input_2_21");
  //hidden fields for pdf and form entry
  var productId = document.getElementById("input_2_15");
  var persons = document.getElementById("input_2_16");
  var watermeter = document.getElementById("input_2_17");
  var prefferedSpot = document.getElementById("input_2_18");
  var regelventiel = document.getElementById("input_2_13");
  var fields = document.getElementsByClassName("gfield__active");
  //API Calls for image changing and specs
  var image = document.getElementById("configurator-image");
  //fetch data
  const URL = window.location;
  const apiUrl =
    URL.origin +
    "/wp-json/aqmos-products/v1/get-data?api_key=76LglA50qE1J8e22N4WO";

  // Fetch the data when the document is loaded
  let apiData = {};

  fetch(apiUrl)
    .then((response) => response.json())
    .then((data) => {
      apiData = data;
    })
    .catch((error) => {
      console.error("Error fetching the data:", error);
    });

  for (var i = 0; i < radios.length; i++) {
    radios[i].addEventListener("change", function () {
      if (fields.length >= 3) {
        nextBtn.classList.remove("btn__disabled");
      } else {
        nextBtn.classList.add("btn__disabled");
      }
      //toggle parent active state
      var parent = this.parentElement.parentElement.parentElement.parentElement;
      var next = parent.nextElementSibling;

      setTimeout(function () {
        if (next) {
          rightWrap.scrollTop = next.offsetTop - 100;
          if (mediaQuery.matches) {
            next.scrollIntoView({ block: "end", behavior: "smooth" });
          } else {
            rightWrap.scrollTop = next.offsetTop - 100;
          }
        } else {
          document
            .querySelector(".aqmos-form__buttons")
            .scrollIntoView({ block: "end", behavior: "smooth" });
        }
      }, 500);

      var valueStore = document.getElementById("input_2_11");
      var productType = document.getElementById("input_2_12");
      if (this.checked) {
        parent.classList.add("gfield__active");

        // var selectedValue = this.value;
        if (this.value == 32 || this.value == 48 || this.value == 72 && this.parentElement.parentElement.id == "input_2_1") {
          valueStore.value = this.value;
          persons.value = this.nextElementSibling.innerText;
        }

        if (this.value == "ja" || this.value == "nee") {

          regelventiel.value = this.value;
        }

        if (this.parentElement.parentElement.id == "input_2_3") {
          watermeter.value = this.nextElementSibling.innerText;
        }

        if (this.parentElement.parentElement.id == "input_2_4") {
          prefferedSpot.value = this.nextElementSibling.innerText;
        }

      

        // Type is productType.value
        //Watermeter is watermeter.value
        // Size is valueStore.value
        // Ventiel us regelventiel.value

        //Stap 1
        if (this.value == 32 || this.value == 48 || this.value == 72) {

          // Als nog leeg is
          if (!productType.value) {
            selectedValue = "r2d2-" + valueStore.value;
            productType.value = "r2d2";
          } else {
            if(productType.value == "cm"){
              if (valueStore.value == 72) {
                selectedValue = productType.value + "-" + 80;

              } else if (valueStore.value == 48) {
                selectedValue = productType.value + "-" + 50;

              } else {
                selectedValue = productType.value + "-" + valueStore.value;

              }

            }

          }
        }

        // Stap 2 watermeter
        // if (this.parentElement.parentElement.id == "input_2_3") {
          if (watermeter.value == "Meterkast" || watermeter.value == "Kruipruimte") {
            productType.value = "bmx";
            if (valueStore.value == 72) {
              selectedValue = productType.value + "-" + 48;
            } else {
              selectedValue = productType.value + "-" + valueStore.value;
            }
          } else {
            productType.value = "r2d2";
            selectedValue = productType.value + "-" + valueStore.value;
          }
        // }

        //Stap 3 voorkeursplek
        // if (this.parentElement.parentElement.id == "input_2_4") {
          if (prefferedSpot.value == "Meterkast") {
            productType.value = "bmx";
            if (valueStore.value == 72) {
              selectedValue = productType.value + "-" + 48;
            } else {
              selectedValue = productType.value + "-" + valueStore.value;
            }
          } else {
            productType.value = "r2d2";
            selectedValue = productType.value + "-" + valueStore.value;
          }
        // }

        //Stap 4 clackventiel
        if (regelventiel.value == "ja" || regelventiel.value == "nee") {
          if (regelventiel.value == "ja") {
            if (productType.value == "r2d2") {
              productType.value = "cm";
              if (valueStore.value == 72) {
                selectedValue = productType.value + "-" + 80;

              } else if (valueStore.value == 48) {
                selectedValue = productType.value + "-" + 50;

              } else {
                selectedValue = productType.value + "-" + valueStore.value;

              }
            } else if (productType.value == "bmx") {
              productType.value = "cmx";
              if (valueStore.value == 72) {
                selectedValue = productType.value + "-" + 48;
              } else {
                selectedValue = productType.value + "-" + valueStore.value;
              }
            }
          } else if(regelventiel.value == "nee") {
            if(productType.value == "cm"){ // r2d2
              productType.value = "r2d2";
              selectedValue = productType.value + "-" + valueStore.value;
            } else if(productType.value == "cmx"){
              productType.value = "bmx";
              if (valueStore.value == 72) {
                selectedValue = productType.value + "-" + 48;
              } else {
                selectedValue = productType.value + "-" + valueStore.value;
              }
            } //mx
          }
        }



        console.log("Selected value: " + selectedValue);
        console.log("Product type: " + productType.value);
        console.log("Preferred spot: " + prefferedSpot.value);
        console.log("Value store: " + valueStore.value);
        console.log("Regelventiel: " + regelventiel.value);
        // console.log("Persons value: " + persons.value);
        console.log("This value: " + this.value);
        console.log("--------------------------");

        // console.log(selectedValue);
        const selectedData = apiData[selectedValue];
        if (selectedData) {
          //if api data found return data
          //add data to hidden fields
          productId.value = selectedData.id;
          model.value = selectedData.title;
          priceField.value = selectedData.price;
          //add data to DOM;
          specsList.innerHTML = "";
          productContent.innerHTML = "";
          if (!specBtn.classList.contains("btn__visible")) {
            specBtn.classList.add("btn__visible");
          }

          productTitle.innerText = selectedData.title;
          price.innerText = selectedData.price;
          //set specs
          for (const key in selectedData.specs) {
            const li = document.createElement("li");
            li.innerHTML = `<strong>${key}:</strong> <span>${selectedData.specs[key]}</span>`;
            specsList.appendChild(li);
          }

          if (selectedData.product_tekst !== null) {
            productContent.innerHTML = selectedData.product_tekst;
          }

          //toggle "loading" classes
          image.classList.add("img-loading");

          setTimeout(function () {
            image.src = selectedData.image;
            image.classList.add("img-load-in");
            image.classList.remove("img-loading");
          }, 400);

          setTimeout(function () {
            image.classList.remove("img-load-in");
          }, 800);
          // You can then display or use this data in any other way you like.
        }
      }
    });

    jQuery(function ($) {
      $("#nextBtn").on("click", function () {
        rightWrap.scrollTop = 0;

        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          dataType: "html",
          data: {
            action: "aqmos_set_cookies",
            productId: productId.value,
            persons: persons.value,
            watermeter: watermeter.value,
            prefferedSpot: prefferedSpot.value,
            regelventiel: regelventiel.value,
          },
          beforeSend: function () {
            console.log("loading...");
          },
          success: function (res) {
            console.log("done!...");
          },
        });
      });

      function changeEventCookie(id, key) {
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          dataType: "html",
          data: {
            action: "aqmos_set_single_cookie",
            key: key,
            value: $("#" + id).val(),
          },
          beforeSend: function () {
            console.log("loading...");
          },
          success: function (res) {
            console.log("done!...");
          },
        });
      }

      nextBtn.addEventListener("click", function nextPage(e) {
        e.preventDefault();

        document.getElementById("gform_next_button_2_6").click();
      });

      jQuery(document).on(
        "gform_page_loaded",
        function (event, form_id, current_page) {
          $("#input_2_7_3").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });

          $("input_2_7_6").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });
          $("#input_2_8_1").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });
          $("#input_2_8_3").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });

          $("#input_2_8_5").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });

          $("#input_2_10").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });

          $("#input_2_9").on("change", function () {
            var key = "";
            if (
              $(this).next() &&
              !$(this).next().attr("data-lastpass-icon-root")
            ) {
              key = $(this).next().text().toLowerCase();
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            } else {
              key = $(this).attr("type");
              console.log(key);
              changeEventCookie($(this).attr("id"), "aqmos_" + key);
            }
          });

          if (current_page == 2) {
            var finalBtn = nextBtn.cloneNode(true);
            finalBtn.innerText = "Verstuur uw gegevens";
            finalBtn.setAttribute("disabled", "disabled");

            nextBtn.parentNode.replaceChild(finalBtn, nextBtn);
            const inputs = document.querySelectorAll(
              '#gform_fields_2_2 input[aria-required="true"]'
            );
            console.log(inputs);
            inputs.forEach((input) => {
              input.addEventListener("input", checkInputs);
            });

            finalBtn.addEventListener("click", function (e) {
              e.preventDefault();
              setTimeout(function () {
                var conf = document.getElementById('gform_confirmation_wrapper_2');
                if (conf) {
                  document.querySelector(".aqmos-form__buttons").style.display =
                    "none";
                }
              }, 300);
              document.getElementById("gform_submit_button_2").click();
            });
          }
        }
      );
    });
  }

  //Toggle specs modal
  specBtn.addEventListener("click", function (e) {
    e.preventDefault();
    sidebar.classList.add("aqmos-sidebar__active");
  });

  modalCloser.addEventListener("click", function (e) {
    e.preventDefault();
    sidebar.classList.remove("aqmos-sidebar__active");
  });

  backdrop.addEventListener("click", function (e) {
    e.preventDefault();
    sidebar.classList.remove("aqmos-sidebar__active");
  });

  //custom next btn

  //custom modal button and append
  var regelVentielLabel = document.querySelector(".regelventiel legend");
  var modalBtn = document.createElement("a");
  modalBtn.classList.add("modal-btn");
  modalBtn.setAttribute("data-bs-toggle", "modal");
  modalBtn.setAttribute("data-bs-target", "#ventiel-modal");
  modalBtn.innerText = "?";
  regelVentielLabel.appendChild(modalBtn);
});

function scrollParentToChild(parent, child) {
  // Where is the parent on page
  var parentRect = parent.getBoundingClientRect();
  // What can you see?
  var parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth,
  };

  // Where is the child
  var childRect = child.getBoundingClientRect();
  // Is the child viewable?
  var isViewable =
    childRect.top >= parentRect.top &&
    childRect.bottom <= parentRect.top + parentViewableArea.height;

  // if you can't see the child try to scroll parent
  if (!isViewable) {
    // Should we scroll using top or bottom? Find the smaller ABS adjustment
    const scrollTop = childRect.top - parentRect.top;
    const scrollBot = childRect.bottom - parentRect.bottom;
    if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
      // we're near the top of the list
      parent.scrollTop += scrollTop;
    } else {
      // we're near the bottom of the list
      parent.scrollTop += scrollBot;
    }
  }
}

function checkInputs() {
  const inputs = document.querySelectorAll(
    '#gform_fields_2_2 input[aria-required="true"]'
  );
  let allFilled = true;
  console.log(inputs);
  inputs.forEach((input) => {
    if (!input.value) {
      allFilled = false;
    }
  });

  if (allFilled) {
    document.getElementById("nextBtn").removeAttribute("disabled");
    console.log("howdy");
  } else {
    document.getElementById("nextBtn").setAttribute("disabled", "disabled");
    console.log("disabled");
  }
}
